import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';
import LoanDrawdown from './LoanDrawdown';

export default function Router(): ReactElement {
    return (
        <Switch>
            <Route exact={true} path='/loans/:loanUuid/drawdowns' component={List} />
            <Route path='/loans/:loanUuid/drawdowns/:loanDrawdownUuid' component={LoanDrawdown} />
        </Switch>
    );
}